import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_FETCH } from '../../services';
import { ENDPOINTS } from '../../constants/endpoints';

export interface SiteDetails {
    workdaySiteNm: string, 
    sapSiteCd: string,
    sapSiteDesc: string,
    timeZoneId: string
}

interface siteDetailsState {
    siteDetails: SiteDetails | null;
    loading: boolean;
    error: string | null;
}

const initialState: siteDetailsState = {
    siteDetails: null,
    loading: false,
    error: null,
};


// ========================================
// ASYNC THUNKS
// ========================================
/**
 * Fetch site details by passing the site code as a query parameter
 * Uses: ENDPOINTS.GET_SITE_DETAILS + siteID
 */
export const fetchSiteDetails = createAsyncThunk(
    'SiteDetails/fetchSiteDetails',
    async (siteCd: string, { rejectWithValue }) => {
        try {
            const response = await API_FETCH(`${ENDPOINTS.GET_SITE_DETAILS}/${siteCd}`);
            console.log('siteDetails raw response:', response);
            return response;
        } catch (error: any) {
            return rejectWithValue(error?.message || 'Failed to fetch site details');
        }
    }
);


// ========================================
// SLICE
// ========================================
const siteDetailsSlice = createSlice({
    name: 'siteDetails',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSiteDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSiteDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.siteDetails = action.payload;
            })
            .addCase(fetchSiteDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearError } = siteDetailsSlice.actions;
export default siteDetailsSlice.reducer;